// src/components/PeoplePlan/TheBench/hooks/useWorkflowData.js
import { useState, useEffect, useCallback } from 'react';
import apiClient from '../../../../apiClient';

const useWorkflowData = (location, workflowName) => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedMUM, setSelectedMUM] = useState(null);
  const [role, setRole] = useState(null);
  const [employeeIds, setEmployeeIds] = useState([]);

  // Parse query params
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const mum = queryParams.get("mum");
    const roleParam = queryParams.get("role");
    const userIds = queryParams.get("user_ids")?.split(",").map(Number) || [];

    if (mum && roleParam && userIds) {
      setSelectedMUM(decodeURIComponent(mum));
      setRole(decodeURIComponent(roleParam));
      setEmployeeIds(userIds);
    } else {
      console.log("No specific workflow parameters provided. Fetching all workflows.");
      setSelectedMUM(null);
      setRole(null);
      setEmployeeIds([]);
    }
  }, [location.search]);

  // Fetch employees - memoized to prevent recreation
  const fetchEmployees = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      console.log("=== FETCH EMPLOYEES DEBUG ===");
      console.log("workflowName:", workflowName);
      console.log("selectedMUM:", selectedMUM);
      console.log("role:", role);
      console.log("employeeIds:", employeeIds);

      let apiPath;

      if (selectedMUM && role && Array.isArray(employeeIds) && employeeIds.length > 0) {
        apiPath = `/api/the-bench-table?workflow_name=${encodeURIComponent(
          workflowName
        )}&mum=${encodeURIComponent(selectedMUM)}&role=${encodeURIComponent(
          role
        )}&user_ids=${employeeIds.join(",")}`;
        console.log("Making SPECIFIC query to:", apiPath);
      } else {
        apiPath = `/api/the-bench-table`;
        console.log("Making GENERAL query to:", apiPath);
      }

      const response = await apiClient.get(apiPath);
      const data = response.data;

      console.log("API Response data type:", typeof data);
      console.log("API Response data length:", Array.isArray(data) ? data.length : "Not an array");

      if (!Array.isArray(data)) {
        console.error("Response data is not an array:", data);
        setEmployees([]);
        return;
      }

      if (data.length === 0) {
        console.log("Empty response from API");
        setEmployees([]);
        return;
      }

      const employeesData = data.flatMap((loc) => {
        console.log("Processing location:", loc.corp, "with", loc.employees?.length || 0, "employees");

        if (!loc.employees || !Array.isArray(loc.employees)) {
          console.error("Location has no employees array:", loc);
          return [];
        }

        return loc.employees.map((employee) => ({
          ...employee,
          corp: loc.corp,
          mum_name: employee.mum_name || "N/A",
          status: employee.status || "New",
        }));
      });

      console.log("Processed employees data:", employeesData.length, "employees");

      // Sort by employee name ascending by default
      const sortedEmployees = [...employeesData].sort((a, b) =>
        a.employee_name.localeCompare(b.employee_name)
      );

      setEmployees(sortedEmployees);
      console.log("=== FETCH COMPLETE ===");
    } catch (err) {
      console.error("=== FETCH ERROR ===");
      console.error("Error details:", err);
      setError(err.message);
      setEmployees([]);
    } finally {
      setLoading(false);
    }
  }, [workflowName, selectedMUM, role, employeeIds]);

  // Fetch on mount and when dependencies change
  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return {
    employees,
    loading,
    error,
    fetchEmployees,
    selectedMUM,
    role,
    employeeIds
  };
};

export default useWorkflowData;
